import { EnvironmentProviders, effect, inject, provideAppInitializer } from '@angular/core';
import { ThemeService } from '@shared/services/theme.service';
import { Chart } from 'chart.js';

/** Chart.js colours for dark mode. Light mode keeps Chart.js's own defaults. */
const darkChartColours = {
  // colour-grayscale-700 in the dark palette - axis labels and legends
  text: '#B6B8BA',
  gridLine: 'rgba(255, 255, 255, 0.12)',
};

/**
 * Chart.js draws on a canvas, so it can't follow the CSS theme. Its default text colour (#666) is too dark to read on
 * a dark page, and its grid lines are invisible. This swaps the defaults when the theme changes and redraws any charts
 * on screen.
 */
export function provideChartTheme(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const themeService = inject(ThemeService);
    const lightChartColours = {
      text: Chart.defaults.color,
      gridLine: Chart.defaults.borderColor,
    };

    effect(() => {
      const colours = themeService.theme() === 'dark' ? darkChartColours : lightChartColours;

      Chart.defaults.color = colours.text;
      Chart.defaults.borderColor = colours.gridLine;
      Object.values(Chart.instances).forEach(chart => chart.update());
    });
  });
}
